__turbopack_context__.v({
  "footer": "ResetPasswordSent-module__xKfe6W__footer",
  "picture": "ResetPasswordSent-module__xKfe6W__picture",
  "wrapper": "ResetPasswordSent-module__xKfe6W__wrapper",
});
